export default "/_next/static/images/2022-3x-a6ecad21121223799c8f529fded9005e.png";